import { render, staticRenderFns } from "./InformationBlock.vue?vue&type=template&id=1366ef84&scoped=true&"
import script from "./InformationBlock.vue?vue&type=script&lang=js&"
export * from "./InformationBlock.vue?vue&type=script&lang=js&"
import style0 from "./InformationBlock.vue?vue&type=style&index=0&id=1366ef84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1366ef84",
  null
  
)

export default component.exports